export const getBadgeIcon = (badge: string) => {
  if (!badge || badge === "None") return null;

  if (badge === "Fairy Queen") return "🧚";
  if (badge === "Star Weaver") return "✨";
  if (badge === "Elven Sage") return "🧝";
  if (badge === "Void Druid") return "🌿";
  if (badge === "Void Walker") return "🔮";
  if (badge === "Cyber Runner") return "👟";
  if (badge === "Grid Master") return "💾";
  if (badge === "Data Miner") return "⛏️";

  return "🚀";
};

/**
 * Count user-visible grapheme clusters in a string. JavaScript's native
 * `String#length` counts UTF-16 code units, which treats a single emoji
 * like 🧝 as 2 (a surrogate pair) and a flag like 🇦🇶 as 4. Spreading
 * into an array iterates code points, which gives us the
 * user-perceived character count we want for badge-length limits.
 */
export const countGraphemes = (text: string): number => {
  return [...(text || "")].length;
};

/**
 * Returns `text` trimmed to fit the badge-length policy:
 *   - 6 graphemes when an emoji is selected as the icon
 *   - 7 graphemes when no icon is selected
 *
 * Defense against two edge cases:
 *   1. The HTML `maxLength` attribute counts UTF-16 code units, not
 *      graphemes, so a paste of a single 4-byte emoji can sneak past
 *      maxLength. We clamp here on the resulting string.
 *   2. Some IMEs (e.g. CJK) emit text in stages that briefly overshoot;
 *      clamping on `change` keeps the saved value policy-conformant.
 */
export const clampBadgeText = (text: string, hasIcon: boolean): string => {
  const max = hasIcon ? 6 : 7;
  const graphemes = [...(text || "")];
  return graphemes.length <= max ? text || "" : graphemes.slice(0, max).join("");
};

